import "./App.css";
import Game from "./Components/game";

function App() {
  return (
    <>
      <Game />
    </>
  );
}

export default App;
